import { ParameterType } from '@/study-search/enums';

import { IIndexation } from '../../../interfaces';
import { SingleValueFilter } from '../SingleValueFilter';
import { FilterKey } from '@studyportals/search-filters';

export class DisciplineFilter extends SingleValueFilter implements IIndexation {
	public constructor() {
		super(FilterKey.DISCIPLINES, ParameterType.DISCIPLINES, []);
	}

	public canBeIndexed(): boolean {
		return this.values.length === 1;
	}
}
